import BaseModifierBehavior from './BaseModifierBehavior';
import { ICardsState } from '../ICardState';

export default class RopeModifierBehavior extends BaseModifierBehavior {
    public isBlocking(state: ICardsState): boolean {
        return this.modifier.properties.plays < 3;
    }
}
